import api from './client';

// Pinned fields for the current user + record_type.
// If user has no rows, the API returns the top-N fields by sort_order
// (the tenant defaults). Hard cap of 15 enforced server-side.

export const getPinnedFields = (recordTypeId) =>
  api.get(`/chat-ai/pinned-fields/${recordTypeId}`).then(r => r.data);

export const savePinnedFields = (recordTypeId, fieldIds) =>
  api.put(`/chat-ai/pinned-fields/${recordTypeId}`, { fieldIds }).then(r => r.data);

export const resetPinnedFields = (recordTypeId) =>
  api.delete(`/chat-ai/pinned-fields/${recordTypeId}`).then(r => r.data);

// All fields for a record type — used by the pin-manager modal so users can
// pick which to pin. Includes visibility_rules so the modal can flag conditional fields.
export const getAvailableFields = (recordTypeId) =>
  api.get(`/chat-ai/pinned-fields/available/${recordTypeId}`).then(r => r.data);
